import styled, { css, keyframes } from 'styled-components'

import A from '../A'
import Icon from '../Icon'
import { mq, sizes } from '../../theme'
import { Card } from '../ContentCard/styled'

type Variants = {
  hasIcon?: boolean
  isActive?: boolean
  variantIcon?: 'only' | 'composite' | 'left'
  variantColor?: string
  variantColorScheme?:
    | 'white' // default
    | 'whiteHoverBlack'
    | 'black'
    | 'colored'
    | 'iconBlack'
    | 'iconWhite'
    | 'iconFullWhite'
    | 'iconRedMojo'
    | 'iconGreenApple'
  disabled?: boolean
}

export const scaleDownBtnDesktop = keyframes`
  0% {
    width: 100%;
  }

  100% {
    width: 3.75rem;
  }
`
export const scaleDownBtnMobile = keyframes`
  0% {
    width: 100%;
  }

  100% {
    width: 3.75rem;
  }
`

export const fadeInText = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`

const containerDiv = styled.div``

const CommonStyles = css<Variants>`
  ${({ theme }) => theme.textStyles.text_bold_condensed_14};
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;
  min-height: 3.5rem;
  overflow: hidden;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  width: ${({ hasIcon, variantIcon }) =>
    hasIcon && variantIcon ? '3.5rem' : 'auto'};
  padding-left: ${({ hasIcon, variantIcon }) =>
    hasIcon && variantIcon ? '0.8rem' : '1rem'};
  padding-right: ${({ hasIcon, variantIcon }) =>
    hasIcon && variantIcon ? '0.8rem' : '1rem'};
  border: ${({ variantColorScheme }) =>
    variantColorScheme &&
    variantColorScheme !== 'white' &&
    variantColorScheme !== 'iconFullWhite'
      ? '2px solid'
      : '1px solid'};
  border-radius: calc(3.5rem / 2);
  outline: 0 none;
  border-color: ${({ theme, variantColorScheme, variantColor }) =>
    variantColorScheme === 'black'
      ? theme.colors.pureBlack
      : variantColorScheme === 'whiteHoverBlack'
      ? theme.colors.pureBlack
      : variantColorScheme === 'colored'
      ? variantColor || theme.colors.redMandy
      : variantColorScheme === 'iconBlack'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconWhite'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconFullWhite'
      ? theme.colors.greyCE
      : variantColorScheme === 'iconRedMojo'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconGreenApple'
      ? theme.colors.pureBlack
      : theme.colors.greyCE};
  color: ${({ theme, variantColorScheme }) =>
    variantColorScheme === 'black'
      ? theme.colors.pureWhite
      : variantColorScheme === 'whiteHoverBlack'
      ? theme.colors.pureBlack
      : variantColorScheme === 'colored'
      ? theme.colors.pureWhite
      : variantColorScheme === 'iconBlack'
      ? theme.colors.pureWhite
      : variantColorScheme === 'iconWhite'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconFullWhite'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconRedMojo'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconGreenApple'
      ? theme.colors.pureBlack
      : theme.colors.pureBlack};
  background-color: ${({ theme, variantColorScheme, variantColor }) =>
    variantColorScheme === 'black'
      ? theme.colors.pureBlack
      : variantColorScheme === 'whiteHoverBlack'
      ? theme.colors.pureWhite
      : variantColorScheme === 'colored'
      ? variantColor || theme.colors.redMandy
      : variantColorScheme === 'iconBlack'
      ? theme.colors.pureBlack
      : variantColorScheme === 'iconWhite'
      ? theme.colors.pureWhite
      : variantColorScheme === 'iconFullWhite'
      ? theme.colors.pureWhite
      : variantColorScheme === 'iconRedMojo'
      ? theme.colors.pureWhite
      : variantColorScheme === 'iconGreenApple'
      ? theme.colors.pureWhite
      : theme.colors.pureWhite};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  transition: color 150ms ease-in-out, border-color 150ms ease-in-out,
    background-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
  cursor: pointer;
  text-decoration: none;

  &:focus {
    box-shadow: 0 0 1px white, 0px 2px 16px rgba(0, 0, 0, 0.3);
  }

  &:disabled,
  &.disabled {
    box-shadow: 0 none;
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  &.disabled {
    opacity: 0.5;
  }

  @media ${mq(sizes.desktop)} {
    height: 4rem;
    border-radius: calc(4rem / 2);
    width: ${({ hasIcon, variantIcon }) =>
      hasIcon && variantIcon === 'only' ? '4rem' : 'auto'};
    padding-left: ${({ hasIcon, variantIcon }) =>
      hasIcon && variantIcon === ('only' || 'composite') ? '1rem' : '1rem'};
    padding-right: ${({ hasIcon, variantIcon }) =>
      hasIcon && variantIcon === ('only' || 'composite') ? '1rem' : '1rem'};
    min-width: ${({ hasIcon, variantIcon }) =>
      hasIcon && variantIcon !== 'only' ? '4rem' : 'auto'};

    ${Card}:hover ${containerDiv}:not(.-no-parent-hover-effect) &:not(:disabled),
    &:hover:not(:disabled):not(.disabled) {
      border-color: ${({ theme, variantColorScheme, variantColor }) =>
        variantColorScheme === 'black'
          ? theme.colors.pureBlack
          : variantColorScheme === 'whiteHoverBlack'
          ? theme.colors.pureBlack
          : variantColorScheme === 'colored'
          ? variantColor || theme.colors.redMandy
          : variantColorScheme === 'iconBlack'
          ? variantColor || theme.colors.redMandy
          : variantColorScheme === 'iconWhite'
          ? variantColor || theme.colors.redMandy
          : variantColorScheme === 'iconFullWhite'
          ? variantColor || theme.colors.redMandy
          : variantColorScheme === 'iconRedMojo'
          ? theme.colors.redMojo
          : variantColorScheme === 'iconGreenApple'
          ? theme.colors.greenApple
          : theme.colors.pureBlack};
      color: ${({ theme, variantColorScheme, variantColor }) =>
        variantColorScheme === 'black'
          ? theme.colors.pureBlack
          : variantColorScheme === 'whiteHoverBlack'
          ? theme.colors.pureWhite
          : variantColorScheme === 'colored'
          ? variantColor || theme.colors.redMandy
          : variantColorScheme === 'iconBlack'
          ? theme.colors.pureWhite
          : variantColorScheme === 'iconWhite'
          ? theme.colors.pureBlack
          : variantColorScheme === 'iconFullWhite'
          ? theme.colors.pureBlack
          : variantColorScheme === 'iconRedMojo'
          ? theme.colors.redMojo
          : variantColorScheme === 'iconGreenApple'
          ? theme.colors.greenApple
          : theme.colors.pureWhite};
      background-color: ${({ theme, variantColorScheme, variantColor }) =>
        variantColorScheme === 'black'
          ? theme.colors.pureWhite
          : variantColorScheme === 'whiteHoverBlack'
          ? theme.colors.pureBlack
          : variantColorScheme === 'colored'
          ? theme.colors.pureWhite
          : variantColorScheme === 'iconBlack'
          ? variantColor || theme.colors.redMandy
          : variantColorScheme === 'iconWhite'
          ? theme.colors.pureWhite
          : variantColorScheme === 'iconFullWhite'
          ? theme.colors.pureWhite
          : variantColorScheme === 'iconRedMojo'
          ? theme.colors.pureWhite
          : variantColorScheme === 'iconGreenApple'
          ? theme.colors.pureWhite
          : theme.colors.pureBlack};
    }
  }

  ${({ isActive, theme }) =>
    isActive &&
    css`
      background-color: ${theme.colors.greenEmerald};
      box-shadow: inset 3px 4px 5px 0 rgba(0, 0, 0, 0.3);
    `}
`

// cta button
export const Button = styled.button<Variants>`
  ${CommonStyles}
`
// cta link
export const Link = styled(A)<Variants>`
  ${CommonStyles}
`

export const Fake = styled.div<Variants>`
  ${CommonStyles}
`
// cta icon
export const ActionIcon = styled(Icon)`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.2rem;
  height: 1.8rem;
  color: inherit;

  & + * {
    margin-left: 1rem;
  }

  & svg {
    display: block;
    max-height: 100%;
    max-width: 100%;
    min-height: 100%;
    min-width: 100%;
  }
`
// cta text
export const ActionText = styled.span<Variants & { $isShrinkable: boolean }>`
  position: relative;
  flex-shrink: ${(props) => (props.$isShrinkable ? 1 : 0)};

  ${({ variantIcon }) =>
    variantIcon === 'composite' &&
    css`
      position: absolute;
      opacity: 0;
      pointer-events: none;
      @media ${mq(sizes.desktop)} {
        position: initial;
        opacity: 1;
        pointer-events: all;
      }
    `}
`

export const Exponent = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
  height: auto;
  padding: 0;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-width: 2.75rem;
  min-height: 2.75rem;
  background: ${({ theme }) => theme.colors.greenApple};
  color: white;
  z-index: 1;
  border-radius: 50%;
  transform: translateY(-45%) translateX(45%);
  line-height: 2.4rem;

  ${({ theme }) => theme.textStyles.text_medium_14};
`
export const Container = styled(containerDiv)`
  display: inline-flex;
  position: relative;
  justify-content: center;

  &.changeButtonHovered {
    ${Fake} {
      background-color: white !important;
      color: black !important;
      border-color: ${({ theme }) => theme.colors.greyCE} !important;
    }
  }

  &.sticky {
    justify-content: flex-start;
    white-space: nowrap;

    ${Button}, ${Link} {
      justify-content: flex-start;
      animation: ${scaleDownBtnMobile} 0.5s ease-in-out forwards;

      @media ${mq(sizes.desktop)} {
        animation: ${scaleDownBtnDesktop} 0.5s ease-in-out forwards;
      }
    }

    ${ActionText} {
      word-wrap: nowrap;
      animation: ${fadeInText} 0.5s ease-in-out forwards;
    }

    ${ActionIcon} {
      flex-shrink: 0;
      transform: translateX(-0.25rem);
    }
  }

  &.-cover {
    z-index: 2;
  }
`

export const Progress = styled.div<{ $value?: number }>`
  position: absolute;
  ${({ $value, theme }) =>
    ($value ?? 0) > 0 &&
    css`
      height: 100%;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      background-color: ${theme.colors.greenMint};
      &: after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: ${($value ?? 0) * 100}%;
        background-color: ${theme.colors.greenEmerald};
      }
    `}
`
